import React from 'react'
import PropTypes from 'prop-types'

import AddButton from './AddButton'
import OrganizationFormDialog from './OrganizationFormDialog'
import OrganizationList from './OrganizationList'

class OrganizationAdmin extends React.Component {
  static propTypes = {
    organizations: PropTypes.object.isRequired,
    onCreateOrg: PropTypes.func.isRequired,
    onUpdateOrg: PropTypes.func.isRequired,
  }

  state = {
    isDialogOpen: false,
    organization: {},
    onSubmit: () => {},
  }

  handleAdd = () => {
    this.setState({
      organization: {},
      onSubmit: this.props.onCreateOrg,
      isDialogOpen: true,
    })
  }

  handleEdit = (organization) => {
    this.setState({
      organization,
      onSubmit: this.props.onUpdateOrg,
      isDialogOpen: true,
    })
  }

  onDialogClose = () => {
    this.setState({
      onSubmit: () => {},
      isDialogOpen: false,
      organization: {},
    })
  }

  render() {
    return (
      <div>
        <AddButton label="Add Organization" onClick={this.handleAdd} />
        <OrganizationList organizations={this.props.organizations} onEdit={this.handleEdit} />

        {this.state.isDialogOpen && (
          <OrganizationFormDialog
            organization={this.state.organization}
            onClose={this.onDialogClose}
            onSubmit={this.state.onSubmit}
          />
        )}
      </div>
    )
  }
}

export default OrganizationAdmin
